// import axios from "axios"

// const api = axios.create({
//  baseURL: process.env.REACT_APP_APIURL,
// })


// export default api;

import axios from "axios";
import Store from "../ReduxToolkit/Store";
import { logout } from "../ReduxToolkit/Reducers/AuthSlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_APIURL,
});

// Request Interceptor - Add token to headers
api.interceptors.request.use(
  (config) => {
    const token = Store.getState().auth.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Handle token expiration (401 Unauthorized)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or unauthorized - logout user
      Store.dispatch(logout());
      
      // Redirect to login page
      window.location.href = `${process.env.PUBLIC_URL}/login`;
    }
    return Promise.reject(error);
  }
);

export default api;
